import { makeAutoObservable, runInAction } from "mobx";
import {
  pagingReport02s,
  getReport02,
  deleteReport02,
  saveReportLevelProvince,
  lockReport,
  unLockReport,
  lockReportBySearch,
  unLockReportBySearch,
  exportimportEnrollmentReportLevelProvince,
} from "./Report02Service";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import LocalConstants from "app/LocalConstants";
import i18n from "i18n";

const defaultItems = LocalConstants.Report02Type.reduce((acc, item) => {
  if (item.type === "in") {
    return acc;
  }
  if (item.value) {
    const row = {
      numberPatientDetectionPrecious: 0,
      numberPatientDetectionPrePrecious: 0,
      numberPatientNotOrganzationDetection: 0,
      numberPatientOther: 0,
      numberPatientTotal: 0,
      reportType: item.value,
    };
    return [...acc, row];
  }
  return acc;
}, []);
const defaultItem2s = LocalConstants.Report02Type2.map((e) => {
  return {
    numberPatientNew: 0,
    numberPatientRelapse: 0,
    numberPatientReTreatmentAfterQuit: 0,
    numberPatientFalied: 0,
    numberPatientOther: 0,
    numberPatientTotal: 0,
    note: "",
    reportType: e.value,
    subItems: [],
  };
});

const initialReport02 = {
  id: "",
  year: null,
  precious: null,
  region: null,
  province: null,
  reporter: "",
  dateReport: null,
  numberPatientAdverseFirstLineDrug: 0,
  items: defaultItems,
  item2s: defaultItem2s,
};

const initialSearchObject = {
  keyword: "",
  region: null,
  province: null,
};

export default class Report01Store {
  report02List = [];
  selectedReport02 = { ...initialReport02 };
  selectedList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 5;
  loadingInitial = false;
  shouldOpenConfirmationDialog = false;
  handleShowTable = false;
  searchObject = { ...initialSearchObject };
  deleteId = "";

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSetSearchObject = (obj) => {
    this.page = 1;
    this.searchObject = { ...obj };
  };

  updatePageData = async () => {
    this.loadingInitial = true;
    const searchObject = {
      // keyword: this.keyword,
      ...this.searchObject,
      regionId: this.searchObject?.region?.id,
      provinceId: this.searchObject?.province?.id,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
    };
    try {
      let data = await pagingReport02s(searchObject);
      this.report02List = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning("toast.load_fail");
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditReport02 = (id) => {
    this.getReport02(id).then(() => {
      this.handleShowTable = false;
    });
  };

  handleClose = () => {
    this.handleShowTable = false;
  };

  handleCloseDeleteDialog = () => {
    this.shouldOpenConfirmationDialog = false;
    this.updatePageData();
  };

  handleOpenDelete = (item) => {
    if (item?.id) {
      this.deleteId = item.id;
      this.shouldOpenConfirmationDialog = true;
    } else {
      toast.warn("Chưa chọn báo cáo cần xoá");
      this.deleteId = "";
    }
  };

  handleConfirmDelete = () => {
    deleteReport02(this.deleteId)
      .then(() => {
        toast.success("Đã xóa thành công");
        this.handleAddNewReport();
      })
      .catch(() => {
        toast.error("Có lỗi xảy ra khi xóa");
      })
      .finally(() => {
        this.deleteId = "";
        this.handleCloseDeleteDialog();
      });
  };

  getReport02 = async (id) => {
    if (id != null) {
      try {
        let data = await getReport02(id);
        this.handleSelectReport02(data?.data);
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectReport02(null);
    }
  };

  handleSelectReport02 = (obj) => {
    let item2s = defaultItems;
    let items = defaultItem2s;
    if (obj?.items?.length > 0) {
      items = LocalConstants.Report02Type.reduce((acc, row) => {
        if (row.type === "in") {
          return acc;
        }
        const rowData = obj?.items?.find(f => f?.reportType === row.value);
        if (rowData) {
          return [...acc, rowData];
        } else {
          if (row.value) {
            const rowData = {
              numberPatientDetectionPrecious: 0,
              numberPatientDetectionPrePrecious: 0,
              numberPatientNotOrganzationDetection: 0,
              numberPatientOther: 0,
              numberPatientTotal: 0,
              reportType: row.value,
            };
            return [...acc, rowData];
          }
        }
        return acc;
      }, []);
    }
    if (obj?.item2s?.length > 0) {
      item2s = LocalConstants.Report02Type2.map((row) => {
        const rowData = obj?.item2s?.find(f => f?.reportType === row.value);
        if (rowData) return rowData;
        return {
          numberPatientNew: 0,
          numberPatientRelapse: 0,
          numberPatientReTreatmentAfterQuit: 0,
          numberPatientFalied: 0,
          numberPatientOther: 0,
          numberPatientTotal: 0,
          note: "",
          reportType: row.value,
          subItems: [],
        }
      });
      if (item2s?.[1]?.subItems?.length > 0) {
        item2s[1].subItems = item2s[1].subItems.sort(
          (a, b) => a?.viewIndex - b?.viewIndex
        );
        item2s[1].subItems = item2s[1].subItems.map((item) => {
          return {
            ...item,
            province: {
              id: item?.provinceId,
              name: item?.provinceName,
            },
          };
        });
      }
    }
    this.selectedReport02 = {
      ...obj,
      items: items,
      item2s,
    };
  };

  createReport02 = async (report01) => {
    try {
      const res = await saveReportLevelProvince(report01);
      this.handleSelectReport02(res?.data);
      toast.success("Thêm mới thành công!");
      // this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi thêm mới!");
    }
  };

  editReport02 = async (report01) => {
    try {
      const res = await saveReportLevelProvince(report01);
      this.handleSelectReport02(res?.data);
      toast.success("Cập nhật thành công!");
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  handleUnLockReport = (id, select = true) => {
    return unLockReport(id)
      .then(({ data }) => {
        if (select || this.selectedReport02?.id === id) {
          this.handleSelectReport02(data);
        }
        toast.success("Bỏ khóa báo cáo thành công!");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Có lỗi xảy vui lòng thử lại sau!");
      });
  };

  handleLockReport = (id, select = true) => {
    return lockReport(id)
      .then(({ data }) => {
        if (select || this.selectedReport02?.id === id) {
          this.handleSelectReport02(data);
        }
        toast.success("Khóa báo cáo thành công!");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Có lỗi xảy vui lòng thử lại sau!");
      });
  };

  handleLockList = (obj) => {
    const searchObject = {
      ...obj,
      regionId: obj?.region?.id,
      provinceId: obj?.province?.id,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
    };
    lockReportBySearch(searchObject)
      .then(() => {
        this.handleSetSearchObject(obj);
        this.updatePageData();
        if (this.selectedReport02?.id) {
          this.getReport02(this.selectedReport02?.id);
        }
        toast.success("Khóa báo cáo thành công!");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Có lỗi xảy vui lòng thử lại sau!");
      });
  };

  handleUnLockList = (obj) => {
    const searchObject = {
      ...obj,
      regionId: obj?.region?.id,
      provinceId: obj?.province?.id,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
    };
    unLockReportBySearch(searchObject)
      .then(() => {
        this.handleSetSearchObject(obj);
        this.updatePageData();
        if (this.selectedReport02?.id) {
          this.getReport02(this.selectedReport02?.id);
        }
        toast.success("Bỏ khóa báo cáo thành công!");
      })
      .catch((err) => {
        console.error(err);
        toast.error("Có lỗi xảy vui lòng thử lại sau!");
      });
  };

  handleExportSampleExcel = () => {
    exportimportEnrollmentReportLevelProvince({})
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "MAU_BAO_CAO_THU_NHAN_NB_LKT.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      });
  };
  setHandleShowTable = () => {
    this.handleShowTable = true;
  };

  handleAddNewReport = (item) => {
    this.handleResetForm(item);
  };

  handleResetForm = (item) => {
    this.selectedReport02 = {};
    setTimeout(() => {
      runInAction(() => {
        this.selectedReport02 = {
          ...initialReport02,
          region: item?.region,
          province: item?.province,
        };
      });
    }, 10);
  };

  resetStoreObject = () => {
    this.selectedReport02 = { ...initialReport02 };
    this.searchObject = { ...initialSearchObject };
  };

  handleSelectList = (list) => {
    this.selectedList = [...list];
  };
}
